

import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

import { FieldDisplay } from './field-display';

import { useResponsiveValue } from '@/hooks/use-responsive-value';
import { hasValue } from '@/lib/utils/has-value';

import { FieldType } from '@/lib/types';

interface Field {
  id: string;
  label: string;
  type?: FieldType;
}

interface SectionDisplayProps {
  title: string;
  fields: Field[];
  data: Record<string, unknown>;
}

export function SectionDisplay({ title, fields, data }: SectionDisplayProps) {
  const resolveResponsive = useResponsiveValue();
  // Filter to only show fields with values
  const fieldsWithValues = fields.filter(field => hasValue(data[field.id]));

  // Don't render section if no fields have values
  if (fieldsWithValues.length === 0) {
    return null;
  }

  return (
    <Paper sx={{ p: 3, borderRadius: 2 }}>
      <Typography variant="h2" sx={{ mb: 2 }}>
        {title}
      </Typography>
      <Grid container spacing={3}>
        {fieldsWithValues.map((field) => (
          <Grid
            key={field.id}
            size={resolveResponsive({ xs: 12, md: field.type === 'textarea' ? 12 : 6 })}
          >
            <FieldDisplay
              label={field.label}
              value={data[field.id]}
              type={field.type}
            />
          </Grid>
        ))}
      </Grid>
    </Paper>
  );
}
